export default "__VITE_ASSET__CA6380aI__"